import { axiosInstance } from "contexts/axiosApiInstance";
import { createLogger } from "debug/DebugingLogger";

const log = createLogger("AccountDeletionServices");

export interface AccountModelInfo {
  model_id: string;
  model_name: string;
  tables: AccountTableInfo[];
}

export interface AccountTableInfo {
  table_id: string;
  table_name: string;
  usage_status: "Critical" | "Moderate" | "Low";
}

interface OrgRef {
  org_id: string;
  name: string;
}

export interface AccountDeletionAnalysis {
  models: AccountModelInfo[];
  /// Orgs that survive the account and keep charging its card.
  orgs_you_pay_for: OrgRef[];
  /// Orgs left with no other live owner; the press refuses while any remain.
  sole_owned_orgs: OrgRef[];
}

export const fetchAccountDeletionAnalysis =
  async (): Promise<AccountDeletionAnalysis> => {
    try {
      const response = await axiosInstance.get(
        "/action/account/deletion-analysis",
      );
      return response.data;
    } catch (error) {
      log.error("Failed to fetch account deletion analysis", error);
      throw error;
    }
  };
